import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconCaliforniaFlag from 'components/icons/iconCaliforniaFlag';
import { withState } from './state';
import DSRForm from './components/DSRForm';
import DSRSuccess from './components/DSRSuccess';
const DSRPage = props => {
  const $ = _c(4);
  const {
    state
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="md:text-center"><IconCaliforniaFlag /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.actions || $[2] !== state) {
    t1 = <div className="md:px-0 md:py-4 md:bg-gray-light9"><div className="max-w-[800px] my-16 mx-auto py-12 px-24 bg-white max-md:p-4 max-md:my-4 max-md:mx-auto">{t0}{state.isSuccess ? <DSRSuccess /> : <><div className="md:text-center"><h1 className="text-4xl text-gray font-bold mb-4">Your data is protected, and in your control.{" "}</h1><h3 className="text-lg text-gray font-bold">Joybird is committed to data protection and privacy laws.{" "}</h3><h4 className="text-base text-gray font-bold">The California Consumer Privacy Act (CCPA) is a new data privacy law that came into effect on January 1, 2020. If you’re a California resident, you can use the form below to request access to, or the deletion of, any of your personal information we may have collected.</h4></div><DSRForm state={state} actions={props.actions} /></>}</div></div>;
    $[1] = props.actions;
    $[2] = state;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
DSRPage.propTypes = {
  actions: PropTypes.object,
  state: PropTypes.object
};
export default withState(DSRPage);